import React, { useState, useMemo } from 'react'
import { useDispatch } from 'react-redux'

import moment from 'moment'

import {
  CardContent, Grid, Button,
  Typography,
  AppBar, Grow, IconButton,
  Paper, TableRow, TableHead, TableContainer,
  TableCell, TableBody, Table, List, ListItem,
  Chip, Divider, Modal, Fade, Backdrop, Toolbar, FormLabel
} from '@material-ui/core'

import CloseIcon from '@material-ui/icons/Close'

import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import { withStyles, ThemeProvider } from '@material-ui/core/styles'

import clsx from 'clsx'

import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers'
import { pickerTheme } from '../../../../utils/variables'
import MomentUtils from '@date-io/moment'

import { NotificationToast } from '../../tools/Toast'

import { updateUnitMonitoring, getOrgUnitInfo } from '../../../../redux/actions'

const StyledSwitch = withStyles({
  switchBase: {
    color: 'white',
    '&$checked': {
      color: '#A4D164'
    },
    '&$checked + $track': {
      backgroundColor: '#A4D164'
    }
  },
  checked: {},
  track: {}
})(Switch)

// const useStyles = makeStyles({
//   table: {
//     minWidth: 0
//   }
// })

/**
 * Returns org unit mgmt monitoring form
 */
const OrgUnitMgmtMonitoring = (props) => {
  const { unitName, newInfo, selectedKey, onSaveBackTrack, classes } = props

  const [form, setForm] = useState({
    daily: false,
    weekdays: false,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
    enabled: true,
    exclusions: []
  })

  const [presentDate] = useState(moment())

  const [openModal, setOpenModal] = useState(false)

  const monitoringExclusions = (
    newInfo
      ? newInfo.exclusions == null
        ? '' : newInfo.exclusions.length !== 0
          ? newInfo.exclusions.map((exclusionDate) => {
            return (moment.unix(exclusionDate.exclusionTime))
          }) : ''
      : ''
  )

  const [pickerDates, setPickerDates] = useState(monitoringExclusions)
  const [newExclusionDates, setNewExclusionDates] = useState([])
  const [deleteExclusionDates, setDeleteExclusionDates] = useState([])
  const [monitoringTime, setMonitoringTimes] = useState({ startTime: '', endTime: '' })

  const dispatch = useDispatch()

  useMemo(() => {
    if (newInfo && typeof newInfo === 'object' && Boolean(Object.keys(newInfo).length)) {
      const {
        daily: newDaily = 0, weekdays: newWeekdays = 0, monday: newMonday = 0, tuesday: newTuesday = 0, wednesday: newWednesday = 0,
        thursday: newThursday = 0, friday: newFriday = 0, saturday: newSaturday = 0, sunday: newSunday = 0,
        monitoringStartTime: newMonitoringStartTime = 0, monitoringEndTime: newMonitoringEndTime = 0,
        disableMonitoring: newDisableMonitoring = 1, exclusions: newExclusions = []
      } = newInfo

      const monitoringInfo = {
        daily: Boolean(newDaily),
        weekdays: Boolean(newWeekdays),
        monday: Boolean(newMonday),
        tuesday: Boolean(newTuesday),
        wednesday: Boolean(newWednesday),
        thursday: Boolean(newThursday),
        friday: Boolean(newFriday),
        saturday: Boolean(newSaturday),
        sunday: Boolean(newSunday),
        enabled: !newDisableMonitoring,
        exclusions: newExclusions
      }

      // HOTFIX: 8/14/25 the ability to directly edit monitoring times from the console was removed.
      // These values will now be displayed in a read only format.
      const endTime = moment(newMonitoringEndTime, 'hh:mm:ss').format('h:mm A')
      const startTime = moment(newMonitoringStartTime, 'hh:mm:ss').format('h:mm A')
      setMonitoringTimes({ startTime, endTime })

      setForm({ ...monitoringInfo })
    }
  }, [newInfo])

  // const onChange = (prop) => e => {
  //   e.preventDefault()
  //   const ts = moment(e.target.value, 'HH:mm').unix()
  //   const m = moment.unix(ts / 1000)
  //   const newForm = { ...form, [prop]: m._i }
  //   log.debug(m)
  //   setForm(newForm)
  // }

  const submitForm = async () => {
    const info = {
      // ...newInfo,
      disableMonitoring: form.enabled ? 0 : 1,
      daily: form.daily ? 1 : 0,
      weekdays: form.daily ? 1 : 0,
      monday: form.monday ? 1 : 0,
      tuesday: form.tuesday ? 1 : 0,
      wednesday: form.wednesday ? 1 : 0,
      thursday: form.thursday ? 1 : 0,
      friday: form.friday ? 1 : 0,
      saturday: form.saturday ? 1 : 0,
      sunday: form.sunday ? 1 : 0,
      newExclusions: (
        newExclusionDates.length !== 0 ? newExclusionDates.map((newDate) => {
          return ({
            exclusionTime: newDate.unix()
          })
        }) : newExclusionDates
      ),
      deleteExclusions: (
        deleteExclusionDates.length !== 0 ? deleteExclusionDates.map((deleteDate) => {
          const { dateExclusionID } = deleteDate
          return ({
            dateExclusionID
          })
        }) : deleteExclusionDates
      )
    }

    const monitoringID = newInfo.monitoringID

    dispatch(updateUnitMonitoring(info, selectedKey, monitoringID, fireSuccess, fireFailure))
    onSaveBackTrack()
  }

  const fireSuccess = () => {
    NotificationToast(false, 'Monitoring options updated successfully!')
    dispatch(getOrgUnitInfo(selectedKey))
  }

  const fireFailure = () => {
    NotificationToast(true, 'Failed to update monitoring options.')
  }

  // useEffect(() => {
  //   if (form.enabled) {
  //     setTableOpen(true)
  //     setTableHide(false)
  //   } else if (!form.enabled) {
  //     setTableOpen(false)
  //   }
  // }, [form])

  // const handleMonitoringToggle = () => {
  //   if (form.enabled === 1) {
  //     setForm({
  //       ...form,
  //       enabled: 0
  //     })
  //   } else {
  //     setForm({
  //       ...form,
  //       enabled: 1
  //     })
  //   }
  // }

  // const handleBackTrack = async (tab) => {
  //   const changesMade = form.daily !== settingsForm.daily || form.weekdays !== settingsForm.weekdays || form.enabled !== settingsForm.enabled ||
  //     form.monday !== settingsForm.monday || form.tuesday !== settingsForm.tuesday || form.wednesday !== settingsForm.wednesday ||
  //     form.thursday !== settingsForm.thursday || form.friday !== settingsForm.friday || form.saturday !== settingsForm.saturday ||
  //     form.sunday !== settingsForm.sunday || form.monitoringStartTime !== settingsForm.monitoringStartTime ||
  //     form.monitoringEndTime !== settingsForm.monitoringEndTime || newExclusionDates.length || deleteExclusionDates.length

  //   onBackTrack(changesMade, tab)
  // }

  const handleDateChange = (date) => {
    if (pickerDates !== '') {
      const tempPickerDates = [...pickerDates]

      const dateIndex = pickerDates.findIndex((pickDate) => {
        return pickDate.format('LL') === date.format('LL')
      })

      if (dateIndex !== -1) {
        tempPickerDates.splice(dateIndex, 1)

        if (tempPickerDates.length === 0) {
          setPickerDates('')
        } else {
          setPickerDates(tempPickerDates)
        }
      } else {
        tempPickerDates.push(date)
        setPickerDates(tempPickerDates)
      }
    } else {
      const tempPickerDates = []
      tempPickerDates.push(date)
      setPickerDates(tempPickerDates)
    }

    const tempNewDates = [...newExclusionDates]

    if (form.exclusions.length !== 0) {
      const findDate = form.exclusions.find((exclusionDate) => {
        const { exclusionTime } = exclusionDate
        return moment.unix(exclusionTime).format('LL') === date.format('LL')
      })

      if (!findDate) {
        const newDateIndex = tempNewDates.findIndex((newDate) => {
          return newDate.format('LL') === date.format('LL')
        })

        if (newDateIndex !== -1) {
          tempNewDates.splice(newDateIndex, 1)
          setNewExclusionDates(tempNewDates)
        } else {
          tempNewDates.push(date)
          setNewExclusionDates(tempNewDates)
        }
      } else {
        const tempDeleteDates = [...deleteExclusionDates]

        const deleteDateIndex = tempDeleteDates.findIndex((deleteDate) => {
          const { exclusionTime } = deleteDate
          return moment.unix(exclusionTime).format('LL') === date.format('LL')
        })

        if (deleteDateIndex !== -1) {
          tempDeleteDates.splice(deleteDateIndex, 1)
          setDeleteExclusionDates(tempDeleteDates)
        } else {
          tempDeleteDates.push(findDate)
          setDeleteExclusionDates(tempDeleteDates)
        }
      }
    } else {
      const newDateIndex = tempNewDates.findIndex((newDate) => {
        return newDate.format('LL') === date.format('LL')
      })

      if (newDateIndex !== -1) {
        tempNewDates.splice(newDateIndex, 1)
        setNewExclusionDates(tempNewDates)
      } else {
        tempNewDates.push(date)
        setNewExclusionDates(tempNewDates)
      }
    }
  }

  const handleDateRender = (MUIdate, selectedDates, dayInCurrentMonth) => {
    let dayClassName = ''
    if (pickerDates.length !== 0) {
      const activeIndex = pickerDates.findIndex((pickDate) => {
        return pickDate.format('LL') === MUIdate.format('LL')
      })

      dayClassName = clsx(classes.day, {
        [classes.nonCurrentMonthDay]: !dayInCurrentMonth || (
          moment().unix() > MUIdate.unix() &&
          moment().format('LL') !== MUIdate.format('LL')
        ),
        [classes.activeDate]: activeIndex !== -1
      })
    } else {
      dayClassName = clsx(classes.day, {
        [classes.nonCurrentMonthDay]: !dayInCurrentMonth || (
          moment().unix() > MUIdate.unix() &&
          moment().format('LL') !== MUIdate.format('LL')
        )
      })
    }

    return (
      <IconButton className={dayClassName} disabled={!dayInCurrentMonth}>
        <span>
          {MUIdate.format('DD')}
        </span>
      </IconButton>
    )
  }

  const handleChipDelete = (date) => {
    if (pickerDates !== '') {
      const tempPickerDates = [...pickerDates]

      const dateIndex = pickerDates.findIndex((pickDate) => {
        return pickDate.format('LL') === date.format('LL')
      })

      if (dateIndex !== -1) {
        tempPickerDates.splice(dateIndex, 1)

        if (tempPickerDates.length === 0) {
          setPickerDates('')
        } else {
          setPickerDates(tempPickerDates)
        }
      }

      if (form.exclusions.length !== 0) {
        const findDate = form.exclusions.find((exclusionDate) => {
          const { exclusionTime } = exclusionDate
          return moment.unix(exclusionTime).format('LL') === date.format('LL')
        })

        if (findDate) {
          const tempDeleteDates = [...deleteExclusionDates]

          const deleteDateIndex = tempDeleteDates.findIndex((deleteDate) => {
            const { exclusionTime } = deleteDate
            return moment.unix(exclusionTime).format('LL') === date.format('LL')
          })

          if (deleteDateIndex !== -1) {
            tempDeleteDates.splice(deleteDateIndex, 1)
            setDeleteExclusionDates(tempDeleteDates)
          } else {
            tempDeleteDates.push(findDate)
            setDeleteExclusionDates(tempDeleteDates)
          }
        }
      }
    }
  }

  const renderDates = () => {
    if (Array.isArray(pickerDates)) {
      const sortedDates = pickerDates.sort((a, b) => {
        return a.unix() - b.unix()
      })

      const dateChips = sortedDates.map((pickDate, index) => {
        return (
          <Grid item key={`date-chip-${index}`} xs={4}>
            <Chip
              label={
                <Typography variant='h6' component='h6'>
                  {pickDate.format('L')}
                </Typography>
              }
              className={classes.pickDateChip}
              onDelete={() => handleChipDelete(pickDate)}
              clickable={false}
            />
          </Grid>
        )
      })

      const actualDateChips = []

      // const unixDates = pickerDates.map((pickDate) => {
      //   return (pickDate.format('L'))
      // })

      dateChips.forEach((dateChip, index, allDateChips) => {
        if ((index + 1) % 3 === 0) {
          actualDateChips.push(
            <div key={`date range: ${index - 1} - ${index + 2}`}>
              <ListItem>
                <Grid direction='row' container justify='center' spacing={3}>
                  {allDateChips.slice(index - 2, index + 1)}
                </Grid>
              </ListItem>
              <Divider variant='middle' />
            </div>
          )
        } else if (index === (allDateChips.length - 1)) {
          const startRange = index % 3
          actualDateChips.push(
            <div key={`date range: ${index} - ${index + 2}`}>
              <ListItem>
                <Grid direction='row' container justify='center' spacing={3}>
                  {allDateChips.slice(index - startRange, index + 2)}
                </Grid>
              </ListItem>
            </div>
          )
        }
      })

      return actualDateChips
    } else {
      return (
        <ListItem alignItems='center'>
          <Typography align='center' variant='h6' className='mx-auto'>
            No Exclusion Dates Selected
          </Typography>
        </ListItem>
      )
    }
  }

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <Modal
        open={openModal}
        BackdropComponent={Backdrop}
        onClose={() => setOpenModal(false)}
        className={classes.dateModal}
        BackdropProps={{
          timeout: 500
        }}
      >
        <Fade in={openModal}>
          <Paper className={classes.modalPaper}>
            <AppBar position='relative' className={classes.dateAppBar}>
              <Toolbar style={{ justifyContent: 'space-between' }}>
                <Typography variant='h6' component='h6'>
                  Select A Date For Monitoring Exclusion
                </Typography>
                <IconButton edge='end' onClick={() => setOpenModal(false)}>
                  <CloseIcon style={{ color: '#FFFFFF' }} />
                </IconButton>
              </Toolbar>
            </AppBar>

            <Grid container justify='center' direction='column' className={classes.modalContainer}>
              <Grid container item direction='row' justify='center' className='h-100'>

                <Grid item xs={12}>
                  <ThemeProvider theme={pickerTheme}>
                    <DatePicker
                      value={Array.isArray(pickerDates) ? pickerDates.slice(-1)[0] : presentDate}
                      onChange={handleDateChange}
                      variant='static'
                      orientation='landscape'
                      renderDay={handleDateRender}
                      clearable
                      minDate={presentDate}
                    />
                  </ThemeProvider>
                </Grid>
              </Grid>

            </Grid>
          </Paper>
        </Fade>
      </Modal>

      <CardContent className='mt-2 ml-2'>
        <Grid item container direction='row' className='mt-4'>
          <Grid item container direction='column' sm={12}>
            <h5 className='font-weight-bold mb-2' style={{ fontSize: '1.5rem', color: '#007bff' }}>Monitoring Options for {unitName}</h5>
            {/* <button onClick={(e) => { e.preventDefault(); checkForm() }}>Check!</button> */}
          </Grid>
        </Grid>
        <Grid item container direction='row'>
          <Grid item container direction='column' sm={6}>
            <FormLabel className='font-weight-bold'>Enable/Disable Monitoring</FormLabel>
            <FormControlLabel
              control={
                <StyledSwitch
                  checked={form.enabled}
                  onChange={() => setForm({ ...form, enabled: !form.enabled })}
                  className='ml-1'
                />
              }
              label={form.enabled ? <span>Enabled (All Days)</span> : <span>Disabled</span>}
            />
          </Grid>
        </Grid>
        <Grid item container justify='center'>
          <Grow in={form.enabled} timeout={500} unmountOnExit>
            <Grid container item direction='column' spacing={4}>

              <Grid container item direction='row'>
                <TableContainer className='' component={Paper}>
                  <Table aria-label='days-table'>
                    <TableHead>
                      <TableRow>
                        <TableCell className='font-weight-bold mt-1' align='center'>Monday</TableCell>
                        <TableCell className='font-weight-bold mt-1' align='center'>Tuesday</TableCell>
                        <TableCell className='font-weight-bold mt-1' align='center'>Wednesday</TableCell>
                        <TableCell className='font-weight-bold mt-1' align='center'>Thursday</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell align='center'>
                          <StyledSwitch
                            checked={form.monday}
                            value='monday'
                            onChange={(e) => { setForm({ ...form, monday: !form.monday }) }}
                          />
                        </TableCell>
                        <TableCell align='center'>
                          <StyledSwitch
                            checked={form.tuesday}
                            value='tuesday'
                            onChange={(e) => { setForm({ ...form, tuesday: !form.tuesday }) }}
                          />
                        </TableCell>
                        <TableCell align='center'>
                          <StyledSwitch
                            checked={form.wednesday}
                            value='wednesday'
                            onChange={(e) => { setForm({ ...form, wednesday: !form.wednesday }) }}
                          />
                        </TableCell>
                        <TableCell align='center'>
                          <StyledSwitch
                            checked={form.thursday}
                            value='thursday'
                            onChange={(e) => { setForm({ ...form, thursday: !form.thursday }) }}
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                    <TableHead>
                      <TableRow>
                        <TableCell className='font-weight-bold mt-1' align='center'>Friday</TableCell>
                        <TableCell className='font-weight-bold mt-1' align='center'>Saturday</TableCell>
                        <TableCell className='font-weight-bold mt-1' align='center'>Sunday</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell align='center'>
                          <StyledSwitch
                            checked={form.friday}
                            value='friday'
                            onChange={(e) => { setForm({ ...form, friday: !form.friday }) }}
                          />
                        </TableCell>
                        <TableCell align='center'>
                          <StyledSwitch
                            checked={form.saturday}
                            value='saturday'
                            onChange={(e) => { setForm({ ...form, saturday: !form.saturday }) }}
                          />
                        </TableCell>
                        <TableCell align='center'>
                          <StyledSwitch
                            checked={form.sunday}
                            value='sunday'
                            onChange={(e) => { setForm({ ...form, sunday: !form.sunday }) }}
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Grid item container direction='row' justify='center'>
                <Typography variant='body1' className='text-muted'>Each day enabled above will be set to monitor during the timeframe listed below.</Typography>
              </Grid>
              <Grid container item direction='row' className='pt-0 pb-0'>
                <Grid item container direction='column' xs={6}>
                  <Typography className='text-muted font-weight-bold' variant='caption'>Start Time:</Typography>
                  <Typography className='text-muted' variant='body1'>{monitoringTime?.startTime}</Typography>
                </Grid>
                <Grid item container direction='column' xs={6}>
                  <Typography className='text-muted font-weight-bold' variant='caption'>End Time:</Typography>
                  <Typography className='text-muted' variant='body1'>{monitoringTime?.endTime}</Typography>
                </Grid>
              </Grid>

              <Grid container item direction='column' justify='center' spacing={1}>
                <Grid item container direction='row'>
                  <Grid item container xs={12} alignContent='center'>
                    <FormLabel className='font-weight-bold m-0'>
                      Monitoring Exclusion:
                    </FormLabel>
                    <Typography variant='subtitle2' className='text-muted' style={{ textTransform: 'none' }}>
                      The dates selected below will automatically be excluded from reporting captures.
                    </Typography>
                  </Grid>

                  {/* <Grid item container xs={2}>
                      <Avatar className={clsx(classes.disabledAvatar, Array.isArray(pickerDates) && classes.enabledAvatar)}>{Array.isArray(pickerDates) ? pickerDates.length : 0}</Avatar>
                    </Grid> */}
                </Grid>

                <Grid item container justify='center' direction='row'>
                  <Grid item container justify='center'>
                    <List className={classes.dateList}>
                      {renderDates()}
                    </List>
                  </Grid>
                  <Grid item container justify='center' className='mt-3'>
                    <Button
                      variant='contained'
                      size='large'
                      className={classes.addExclusionBtn}
                      onClick={() => setOpenModal(true)}
                    >
                      Add Exclusions
                    </Button>
                  </Grid>
                </Grid>
              </Grid>

            </Grid>

          </Grow>
        </Grid>

        <Grid item container direction='column' sm={12}>
          <Grid item container direction='row' className='justify-content-end'>
            <Button
              className={`${classes.saveBtn} mt-3`}
              onClick={(e) => { e.preventDefault(); submitForm() }}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </MuiPickersUtilsProvider>
  )
}

export default OrgUnitMgmtMonitoring
